import { render, staticRenderFns } from "./HamletStaticTableV1.vue?vue&type=template&id=38717c38&"
import script from "./HamletStaticTableV1.vue?vue&type=script&lang=js&"
export * from "./HamletStaticTableV1.vue?vue&type=script&lang=js&"
import style0 from "./HamletStaticTableV1.vue?vue&type=style&index=0&id=38717c38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports